import DetailsBlockComponent from './DetailsBlockComponent';
export * from './DetailsBlockComponent';
export default DetailsBlockComponent;
